import styled from 'styled-components'

import { desktop, mobile } from '@/utils/media-query'

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:not(:first-child) {
    margin-top: 50px;
  }

  &:not(:last-child) {
    margin-bottom: 50px;
  }

  && > *:first-child,
  && > *:first-child > *:first-child {
    margin-top: 0;
  }

  && > *:last-child,
  && > *:last-child > *:last-child {
    margin-bottom: 0;
  }

  @media ${mobile.query} {
    &:not(:first-child) {
      margin-top: 25px;
    }

    &:not(:last-child) {
      margin-bottom: 25px;
    }
  }
`

export const Section = styled.section`
  box-sizing: border-box;
  width: auto;

  @media ${desktop.query} {
    margin: auto;
    max-width: ${({ theme }) => theme.containerWidth}px;
    width: 100%;
  }
`
